import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import { action, makeObservable } from 'mobx'
import * as R from 'ramda'
import i18n from 'i18next'
import ModalHeader from '../../../UniformComponents/ModalHeader'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Tabs from './Tabs'
import StagedForm from './StagedForm'
import Spinner from '../../../UniformComponents/Spinner'

@observer
class KpiDataSetup extends PureComponent {
    fields={}

    constructor(props) {
        super(props)
        makeObservable(this)
        this.init()
        this.state = {
            openAccordian: false,
        }
    }

    init = async () => {
        const { dashboardWizardStore } = this.props
        await dashboardWizardStore.initDataSetup()
        this.setDefaults()
    }

    controls = () => [
        {
            name: 'dataLevel',
            type: 'select',
            label: i18n.t('dynamicDash.wizard.dataLevelLabel'),
            tooltipText: i18n.t('dynamicDash.wizard.dataLevelTooltip'),
            options: (store) => R.pathOr([], ['dataLevels'], store),
            onChange: (v) => { this.changeDataLevel(v, 'dataLevel') },
            isMandatory: true,
            show: () => this.showSelect(['dataLevels']),
        },
        {
            name: 'timePeriod',
            type: 'select',
            label: i18n.t('dynamicDash.wizard.timePeriodLabel'),
            tooltipText: i18n.t('dynamicDash.wizard.timePeriodTooltip'),
            options: (store) => {
                const { dashStore } = store
                const { oId } = dashStore
                return oId === 6 ? [
                    { value: 'YOY', label: 'Year On Year' },
                ] : R.pathOr([], ['timePeriodOptions', store.newWidget.dataLevel], store)
            },
            onChange: (v) => { this.onChange(v, 'timePeriod') },
            isMandatory: true,
            show: () => this.showTimePeriod(),
        },
        {
            name: 'optionsAccordion',
            title: i18n.t('dynamicDash.wizard.optionalSettings'),
            type: 'accordion',
            isOpen: this.state.openAccordian,
            toggleOpen: () => this.setState({ openAccordian: !this.state.openAccordian }),
            show: (store) => {
                if (store.dashStore.oId === 6) return 0
                if (!store.newWidget.dataLevel) return 0
                return 2
            },
            id: 1,
        },
        {
            name: 'filter',
            type: 'treeViewSelect',
            label: i18n.t('dynamicDash.wizard.optionalFiltersLabel'),
            tooltipText: i18n.t('dynamicDash.wizard.optionalFiltersTooltip'),
            options: (store) => {
                store.createTreeData(
                    R.pathOr([], ['newWidget', 'dataLevel'], store),
                    R.pathOr([], ['newWidget', 'filter'], store),
                )

                return store.filterTree
            },
            onChange: (v) => { this.onChange(v, 'filter') },
            show: (store) => {
                if (store.newWidget.dataLevel === 'client') return 0
                if (store.dashStore.oId === 6) return 0
                if (!store.newWidget.dataLevel) return 0
                return 2
            },
            validate: (({ value }) => !!value.length),
            accordionId: 1,
        },
        process.env.USE_CUSTOM_BENCHMARKS === 'true' ? {
            name: 'customTag',
            type: 'select',
            label: i18n.t('dynamicDash.wizard.groupByLabel'),
            tooltipText: i18n.t('dynamicDash.wizard.groupByTooltip'),
            options: (store) => [
                { label: 'None', value: 0, tagOptions: [] },
                ...store.benchmarkTags.map((b) => (
                    {
                        value: b.customTagId,
                        label: b.parentTagName || b.customTagName,
                        tagOptions: b.tagOptions,
                    }
                ))],
            onChange: (v) => {
                this.onChange(v || undefined, 'customTag')
                this.onChange({
                    value: v.tagOptions.map((b) => (
                        { value: b.tagOptionId, label: JSON.parse(b.tagOptionConfig).name }
                    )),
                }, 'tagOptions')
            },
            dontAutoSet: true,
            isMandatory: false,
            show: (store) => {
                if (!store.benchmarkTags.length) return 0
                if (store.dashStore.oId === 6) return 0
                if (!store.newWidget.dataLevel) return 0
                return 2
            },
            accordionId: 1,
        } : undefined,
        process.env.USE_CUSTOM_BENCHMARKS === 'true' ? {
            name: 'tagOptions',
            type: 'select',
            label: i18n.t('dynamicDash.wizard.customFiltersLabel'),
            tooltipText: i18n.t('dynamicDash.wizard.customFiltersTooltip'),
            options: (store) => {
                const customTag = store.benchmarkTags
                    .find((b) => b.customTagId === R.pathOr(undefined, ['customTag'], store.newWidget))
                return R.pathOr([], ['tagOptions'], customTag)
                    .map((b) => (
                        { value: b.tagOptionId, label: JSON.parse(b.tagOptionConfig).name }
                    ))
            },
            isMulti: true,
            onChange: (v) => { this.onChange(v, 'tagOptions') },
            dontAutoSet: true,
            isMandatory: false,
            show: (store) => {
                if (!store.newWidget.customTag) return 0
                if (!store.benchmarkTags.length) return 0
                if (store.dashStore.oId === 6) return 0
                if (!store.newWidget.dataLevel) return 0
                return 2
            },
            accordionId: 1,
        } : undefined,
    ]

    @action
    setDefaults = () => {
        const { dashboardWizardStore } = this.props
        const { changeNewWidget } = dashboardWizardStore
        this.controls().forEach((c) => {
            const options = c.options ? c.options(dashboardWizardStore) : []
            if (options.length === 1 && !c.dontAutoSet && c.name !== 'filter') {
                changeNewWidget(options[0].value, c.name)
            }
        })
    }

    onChange = async ({ value }, field) => {
        const { dashboardWizardStore } = this.props
        const { changeNewWidget } = dashboardWizardStore
        changeNewWidget(value, field)
        this.setDefaults()
    }

    changeDataLevel = (v, field) => {
        const { dashboardWizardStore } = this.props
        dashboardWizardStore.createTreeData(
            v.value,
            R.pathOr([], ['newWidget', 'filter'], dashboardWizardStore),
        )
        this.onChange(v, field)
    }

    showSelect = (options) => {
        const { dashboardWizardStore } = this.props
        const storeOptions = R.pathOr([], options, dashboardWizardStore)
        if (storeOptions.length > 1) {
            return 2
        }
        if (storeOptions.length === 1) {
            return 1
        }
        return 1
    }

    showTimePeriod = () => {
        const { dashboardWizardStore } = this.props
        // if (dashboardWizardStore.dashStore.oId === 6) return 0
        if (!dashboardWizardStore.newWidget.dataLevel) return 1
        return 2
    }

    register = (name, validate) => {
        this.fields[name] = validate
    }

    unregister = (name) => {
        Reflect.deleteProperty(this.fields, name)
    }

    complete = () => {
        const { dashboardWizardStore } = this.props
        const { newWidget, nextStage } = dashboardWizardStore
        const valid = Object.keys(this.fields).reduce((isValid, f) => {
            const currentValid = this.fields[f]({ value: newWidget[f], name: f }, true)
            if (!isValid || !currentValid) return false
            return true
        }, true)
        if (valid) nextStage()
    }

    render() {
        const { dashboardWizardStore } = this.props
        const { previousStage, loading } = dashboardWizardStore
        if (loading) return <Spinner />
        return (
            <div className="eventSetup">
                <Tabs dashboardWizardStore={dashboardWizardStore} />
                <ModalHeader cssClass="header">
                    <div className="title">
                        Data Setup
                    </div>
                    <div className="subTitle">
                        Enter your event requirements below
                    </div>
                </ModalHeader>
                <div className="body">
                    <StagedForm
                        store={dashboardWizardStore}
                        controls={this.controls().filter((c) => !!c)}
                        valueHolder={dashboardWizardStore.newWidget}
                        register={this.register}
                        unregister={this.unregister}
                    />
                </div>
                <ModalFooter>
                    <Button
                        label="Back"
                        cssClass="tertiary regular"
                        style={{ marginRight: '25px', width: '134px' }}
                        onClick={previousStage}
                    />
                    <Button
                        label="Continue"
                        cssClass="primary regular"
                        style={{ width: '134px' }}
                        onClick={this.complete}
                    />
                </ModalFooter>
            </div>
        )
    }
}

export default KpiDataSetup
